import { KS_CONTACT, kshetrapalDeveloper, buildFaqs } from "./developer";

const infinity = {
    slug: "shree-kshetrapal-infinity",
    visibility: "public",
    name: "Shree Kshetrapal Infinity",
    tagline: "Commercial Complex · Mirzapar Road",
    category: "commercial",
    typeLabel: "Commercial",
    areaLabel: null,
    city: "Bhuj",
    citySlug: "bhuj",
    locality: "Mirzapar Road",
    status: "Under Construction",
    priceLabel: null,
    developer: { name: "Shree Kshetrapal Infra LLP" },
    whatsapp: KS_CONTACT.whatsapp,
    phone: KS_CONTACT.phone,
    phoneDisplay: KS_CONTACT.phoneDisplay,
    coverImage: "https://shreekshetrapal.in/storage/2025/09/infinity.webp",
    hero: {
        image: "https://shreekshetrapal.in/storage/2025/09/infinity.webp",
        overline: "Commercial · Mirzapar Road, Bhuj",
        lines: ["Shree Kshetrapal", "Infinity"],
        sub: "An exceptional commercial complex in the heart of Bhuj — state-of-the-art facilities, modern amenities and a prime, high-visibility location.",
    },
    sections: [
        {
            type: "overview",
            overline: "Overview",
            title: "Where business meets opportunity.",
            paragraphs: [
                "Shree Kshetrapal Infinity is an exceptional commercial complex designed to elevate your business to new heights. Located in the heart of Bhuj, it offers state-of-the-art facilities, modern amenities and a prime location with high visibility and accessibility.",
                "Whether you're seeking a space for your retail shop, corporate office or showroom, Infinity provides the perfect environment for your business to thrive — a community where businesses can grow and connect with the city's vibrant energy.",
            ],
            facts: [
                { label: "Status", value: "Under Construction" },
                { label: "Type", value: "Commercial" },
                {
                    label: "Address",
                    value:
                        "Plot No. 4-5, Opp. Hyundai Showroom, Ganga Nagar, Mirzapar Road, Bhuj–Kutch",
                },
            ],
        },
        {
            type: "highlights",
            overline: "Highlights",
            title: "Why Infinity stands out.",
            items: [
                {
                    title: "Heart of Bhuj",
                    text: "On Mirzapar Road at Ganga Nagar, opposite the Hyundai showroom.",
                },
                {
                    title: "Retail, offices & showrooms",
                    text: "Spaces planned for retail shops, corporate offices and showrooms.",
                },
                {
                    title: "High visibility",
                    text: "A prime location with strong visibility and easy accessibility.",
                },
                {
                    title: "3 dedicated elevators",
                    text: "Multiple elevators for smooth movement across floors.",
                },
                {
                    title: "Fire safety planned",
                    text: "Fire-safety systems included in the building plan.",
                },
                {
                    title: "24×7 security & CCTV",
                    text: "Round-the-clock security with camera surveillance.",
                },
            ],
        },
        {
            type: "amenities",
            overline: "Amenities",
            title: "Comfort, security and convenience.",
            note: "Amenity list as published by the developer.",
            items: [
                { icon: "ArrowUpDown", name: "3 Dedicated Elevators", desc: "Fast vertical access." },
                { icon: "Car", name: "Car Parking", desc: "Planned parking for tenants and visitors." },
                { icon: "Video", name: "CCTV Surveillance", desc: "Camera coverage across the complex." },
                { icon: "Droplets", name: "Water Tanks", desc: "Planned water storage and supply." },
                { icon: "ShieldCheck", name: "24×7 Security", desc: "Round-the-clock on-site security." },
                { icon: "Flame", name: "Fire Safety", desc: "Fire-safety systems as per plan." },
            ],
        },
        {
            type: "plans",
            overline: "Floor Plans",
            title: "Three commercial floors.",
            note: "Plans as published by the developer. Tap any plan to view it full size.",
            items: [
                {
                    label: "Ground Floor",
                    image: "https://shreekshetrapal.in/storage/2024/10/Infinity_GF_Plan.jpg",
                },
                {
                    label: "First Floor",
                    image: "https://shreekshetrapal.in/storage/2024/10/Infinity_FF_Plan.jpg",
                },
                {
                    label: "Second Floor",
                    image: "https://shreekshetrapal.in/storage/2024/10/Infinity_SF_Plan.jpg",
                },
            ],
        },
        {
            type: "gallery",
            overline: "Gallery",
            title: "Infinity in renders.",
            caption: "Imagery courtesy of Shree Kshetrapal Infra LLP.",
            images: [
                {
                    src: "https://shreekshetrapal.in/storage/2025/09/3-1.webp",
                    caption: "Elevation render",
                    span: 6,
                },
                {
                    src: "https://shreekshetrapal.in/storage/2025/09/2-1.webp",
                    caption: "Architectural render",
                    span: 6,
                },
            ],
        },
        {
            type: "location",
            overline: "Location",
            title: "Mirzapar Road, Bhuj.",
            image: "https://shreekshetrapal.in/storage/2024/10/KSPL-All-Booklet-Keyplan_page-0002.jpg",
            addressLines: [
                "Plot No. 4-5, Opp. Hyundai Showroom,",
                "Ganga Nagar, Mirzapar Road, Bhuj – Kutch, Gujarat",
            ],
            mapUrl: "https://maps.app.goo.gl/6bvrrHtTjvanATDaA",
            landmarks: [
                { name: "Jubilee Ground", detail: "3.9 km" },
                { name: "Bhuj Bus Station", detail: "5.3 km" },
                { name: "Bhuj Railway Station", detail: "7 km" },
                { name: "Bhuj Airport", detail: "8.4 km" },
            ],
            note: "Distances as published by the developer. Keyplan image courtesy of the developer.",
        },
        { type: "developer", ...kshetrapalDeveloper },
        buildFaqs("Shree Kshetrapal Infinity"),
        {
            type: "cta",
            overline: "Connect Directly",
            title: "Talk to the Infinity team.",
            text: "Ask for current pricing, unit availability, payment plans or a site visit — your message goes straight to Shree Kshetrapal Infra LLP. No brokers in between.",
            brochureUrl:
                "https://shreekshetrapal.in/wp-content/uploads/2025/06/INFINITY.pdf",
        },
    ],
};

export default infinity;
